import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import packageJson from "../../../../package.json";

class Footer extends Component {
    render() {
        return (
            <footer>
                <div className="ft-txt ft-policy">
                    v{packageJson.version} <span> | </span>
                    <span data-tip="2025 FCA Tracker All Rights Reserved" className="cursor-hand" data-for="copyrightTooltip">
                        ©
                    </span>
                    <span> | </span>{" "}
                    <span onClick={() => window.open("/privacypolicy", "_blank")} className="cursor-hand">
                        Privacy Policy
                    </span>
                    <ReactTooltip place="right" id="copyrightTooltip" className="rc-tooltip-custom-class " effect="solid" backgroundColor="#007bff" />
                </div>
            </footer>
        );
    }
}

export default withRouter(Footer);
